import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

/**
 * A container that every main lesson component should be wrapped in.
 */
const LessonContainer = ({className, children, ...props}) => (
    <div {...props} className={classNames('lesson mx-2 md:mx-4', className)}>
        {children}
    </div>
);

LessonContainer.defaultProps = {
    className: null,
    children: null,
};

LessonContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default LessonContainer;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Lesson/LessonContainer.js